import { render, staticRenderFns } from "./AssignedRoutineDetail.vue?vue&type=template&id=15b716ed&scoped=true"
import script from "./AssignedRoutineDetail.vue?vue&type=script&lang=js"
export * from "./AssignedRoutineDetail.vue?vue&type=script&lang=js"
import style0 from "./AssignedRoutineDetail.vue?vue&type=style&index=0&id=15b716ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b716ed",
  null
  
)

export default component.exports